var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vfoot"},[_c('b-container',{staticClass:"bv-example-row",attrs:{"fulid":""}},[_c('p',{on:{"click":_vm.open}},[_vm._v("京 ICP 备 17073622 号-5")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }